import PredictorWebApiHandler from '../pedictorWebApiHandler';

const END_POINTS = {
  prefix: 'Users',
  info: 'info',
  checkUsername: 'checkUsername',
  userWinningRoundsInfo: 'userWinningRoundsInfo',
  updateShowUserWinningRounds: 'updateShowUserWinningRounds',
  generateNickname: 'generateNickname',
};

class UsersApiHandler extends PredictorWebApiHandler {
  constructor(prefix){
    super(prefix);
  }

  getUserInfo() {
    return this.get(END_POINTS.info)
  }

  postUserInfo(payload) {
    return this.put(END_POINTS.info, payload);
  }

  checkUsername(query){
    return this.get(END_POINTS.checkUsername, query);
  }

  generateNickname() {
    return this.post(END_POINTS.generateNickname);
  }

  getUserWinningInfo() {
    return this.get(END_POINTS.userWinningRoundsInfo);
  }

  updateUserWinningInfo(payload) {
    return this.put(END_POINTS.updateShowUserWinningRounds, payload);
  }
}

const usersApiHandler = new UsersApiHandler(END_POINTS.prefix);
export default usersApiHandler;
